module.exports = __webpack_public_path__ + "img/47e0e01.jpg";